
import { React, useEffect, useState } from "react";
import TextFieldWithButton from "../CommonFields/Textfieldwithbutton";
import { url } from "../../config/url";
import { userByToken } from "../../api/auth.api";
import { checkEmail, validateEmailOtp, applySubscription } from "../../api/account.api";
import { toastError, toastSuccess } from "../../Utilities/toast";
import Countdown from 'react-countdown';
import { kFormatter } from '../../Utilities/kFormatter';
import { useProfileDataContext } from '../ProfileContext/ProfileContext';

const SubscriptionPopup = ({ isOpen, title, onClose, subscriptionItem, handleSubscription, children, setEmailIdForPayment }) => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtp, setIsOtp] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [otpError, setOTPError] = useState("");
  const [userDetails, setUserDetails] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { fetchAccountProfile } = useProfileDataContext();

  const handleButtonClick = async () => {
    setOtp("");
    setEmailError("");
    let validateEmailRes = validateEmail(email)
    if (!validateEmailRes) {
      setEmailError("please enter valid email id");
      return;
    }
    else {
      try {
        const res = await checkEmail({
          email: email
        });
        if (res?.success) {
          setIsOtp(true)
        }
        else {
          setIsOtp(false)
          toastError(res?.data?.errors?.[0]?.msg);
        }
      } catch (error) {
        setIsOtp(false)
        toastError(error?.response?.data?.errors?.[0]?.msg);
      }
    }
  };
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
  const validateOtp = (otp) => {
    const value = otp;
    // Allow only numbers and restrict length to 10 digits
    if (/^\d*$/.test(value) && value.length <= 6) {
      return true
    }
    else {
      return false
    }
  };
  const handleValidateButtonClick = async () => {
    setOTPError("");
    if (otp === "") {
      setOTPError("Please enter otp");
    } else if (otp.length < 6) {
      setOTPError("Please enter a 6 digit otp");
    } else {
      try {
        const res = await validateEmailOtp({
          otp: otp
        });
        if (res?.success) {
          setEmailIdForPayment(email)
          fetchAccountProfile()
          setOtp("");
          setIsOtp(false)
          fetchUserDetails();
          userDetails.email = email;
          handleSubscription(userDetails, subscriptionItem);
          onClose();
          // redeemSubscription();
        }
        else {
          // setOtp("");
          // setIsOtp(false)
          toastError(res?.data?.errors?.[0]?.msg);
        }
      } catch (error) {
        // setOtp("");
        // setIsOtp(false)
        toastError(error?.response?.data?.errors?.[0]?.msg);
      }
    }
  }

  useEffect(() => {
    let userProfileFromLocal = JSON?.parse(localStorage?.getItem("profile"))
    setUserDetails(userProfileFromLocal)
    setEmail(userProfileFromLocal?.email)
  }, [])

  const fetchUserDetails = async () => {
    setIsLoading(true);
    try {
      const res = await userByToken();
      if (res?.success && res?.data) {
        setIsLoading(false);
        setUserDetails(res?.data)
        // setUserData(res?.data)
        setEmail(res?.data?.email)
      }
      else {
        setIsLoading(false);
        setUserDetails("")
      }
    } catch (error) {
      setIsLoading(false);
      setUserDetails("")
    }
  };
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a completed state
      setOtp("");
      setIsOtp(false)
      return <></>;
    } else {
      // Render a countdown
      return <>Request for a new one in {minutes}:{seconds} seconds</>;
    }
  };
  const getTotalBalance = (_id) => {
    let index = userDetails?.wallet?.findIndex((obj) => obj.currency == _id);

    if (index > -1) {
      return userDetails?.wallet[index].winningAmount ? userDetails?.wallet[index].winningAmount : 0;
    }
    return 0;
  };
  const redeemSubscription = async () => {
    try {
      if (userDetails?.email && userDetails?.isEmailVerified) {
        // toastSuccess(res?.data?.[0]?.msg);
        handleSubscription(userDetails, subscriptionItem);
        onClose();
      }
    } catch (error) {
      toastError(error?.response?.data?.errors?.[0]?.msg);
      onClose();
    }
  };

  return (
    !isLoading ?
      <div className="popupinner-wrapper">
        <div className="popup-overlay">
          <div className="popup-container">
            <button className="close-btn" onClick={onClose}>
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g opacity="0.8" filter="url(#filter0_b_2731_8186)">
                  <circle
                    cx="16"
                    cy="16"
                    r="16"
                    fill="#82838E"
                    fill-opacity="0.5"
                  />
                </g>
                <rect
                  x="12.0531"
                  y="10.9065"
                  width="13.3333"
                  height="1.96078"
                  rx="0.980392"
                  transform="rotate(45 12.0531 10.9065)"
                  fill="#F4F4F4"
                />
                <rect
                  x="10.6666"
                  y="20.3345"
                  width="13.3333"
                  height="1.96078"
                  rx="0.980392"
                  transform="rotate(-45 10.6666 20.3345)"
                  fill="#F4F4F4"
                />
                <defs>
                  <filter
                    id="filter0_b_2731_8186"
                    x="-24"
                    y="-24"
                    width="80"
                    height="80"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
                    <feComposite
                      in2="SourceAlpha"
                      operator="in"
                      result="effect1_backgroundBlur_2731_8186"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_backgroundBlur_2731_8186"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </button>
            <div className="popup-title-img-wrap">
              <div style={{ display: "flex", flexFlow: "column", alignItems: "center", justifyContent: "center", paddingTop: "1rem", paddingBottom:"2rem" }}> 

                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M72.4261 13.9172V16.8522H71.7649V13.9172H70.7031V13.3462H73.4829V13.9172H72.4261ZM74.4832 14.5282V16.8522H73.8672V13.3462H74.6285L75.6903 15.9356L76.7521 13.3462H77.5134V16.8522H76.8974V14.5282L75.9407 16.8522H75.4399L74.4832 14.5282Z" fill="#FEFEFE" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M54.323 52.7652H68.403V13.3335H54.323V52.7652ZM35.6435 13.3335L26.5286 50.0767L17.4136 13.3335H3.33337L13.1153 52.7652H39.9419L49.7237 13.3335H35.6435Z" fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M69.027 64.9813C69.027 69.1991 65.5956 72.6185 61.3625 72.6185C57.1295 72.6185 53.6979 69.1991 53.6979 64.9813C53.6979 60.7633 57.1295 57.3438 61.3625 57.3438C65.5956 57.3438 69.027 60.7633 69.027 64.9813Z" fill="#FFC600" />
                </svg>
                <svg width="176" height="29" viewBox="0 0 176 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.894844 28V-1.90735e-06H12.1348C17.9748 -1.90735e-06 21.4148 3.6 21.4148 8.68C21.4148 13.76 17.9748 17.36 12.1348 17.36H6.17484V28H0.894844ZM6.17484 12.92H11.8548C14.9748 12.92 16.2548 10.92 16.2548 8.68C16.2548 6.44 14.9748 4.44 11.8548 4.44H6.17484V12.92ZM45.1992 20.52L45.8792 28H40.6392L39.9592 21.12C39.7992 19 38.3192 17.48 36.1992 17.48H30.1592V28H24.8792V-1.90735e-06H36.3192C42.1992 -1.90735e-06 45.6392 3.56 45.6392 8.64C45.6392 11.52 44.1992 13.52 41.8792 14.68C43.7992 15.92 44.9992 17.96 45.1992 20.52ZM30.1592 4.44V12.92H36.0792C39.1992 12.92 40.4792 10.88 40.4792 8.64C40.4792 6.4 39.1992 4.44 36.0792 4.44H30.1592ZM51.3636 28V-1.90735e-06H69.9636V4.56H56.6036V11.36H67.3236V15.92H56.6036V23.4H70.4036V28H51.3636ZM74.5277 28V-1.90735e-06H80.6077L89.0877 20.68L97.5677 -1.90735e-06H103.648V28H98.7277V9.44L91.0877 28H87.0877L79.4477 9.44V28H74.5277ZM109.02 28V-1.90735e-06H114.3V28H109.02ZM130.125 28.32C123.605 28.32 119.125 24.68 119.125 17.88V-1.90735e-06H124.125V17.92C124.125 21.76 126.565 23.68 130.125 23.68C133.685 23.68 136.165 21.76 136.165 17.92V-1.90735e-06H141.125V17.88C141.125 24.68 136.685 28.32 130.125 28.32ZM145.973 28V-1.90735e-06H152.053L160.533 20.68L169.013 -1.90735e-06H175.093V28H170.173V9.44L162.533 28H158.533L150.893 9.44V28H145.973Z" fill="#EE2737" />
                </svg>
              </div>
              <h2 className="popup-header w-100">{title}</h2>
            </div>

            <div className="space-between">
              {(!userDetails?.email || !userDetails?.isEmailVerified) &&
                <div className="popup-body">
                  <TextFieldWithButton
                    label="email ID"
                    placeholder="enter email id here"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    buttonText="Send OTP"
                    onButtonClick={handleButtonClick}
                    showButton={isOtp ? false : true}
                    // readOnly={userDetails?.email || isOtp}
                    readOnly={userDetails?.isEmailVerified}
                  />
                  {emailError && (
                    <div
                      className="error-message"
                      style={{ fontSize: "12px", position: "static" }}
                    >
                      {emailError}
                    </div>
                  )}{" "}
                </div>
              }
              {isOtp &&
                <>
                  <div className="popup-body">
                    <TextFieldWithButton
                      label="enter otp"
                      placeholder="enter otp"
                      value={otp}
                      onChange={(e) => {
                        setOTPError("");
                        const digitOnlyRegex = /^\d*$/;
                        if (!digitOnlyRegex.test(e.target.value)) {
                          setOTPError("please enter a valid 6-digit otp")
                          return
                        }
                        setOtp(e.target.value)
                      }}
                      showButton={false}
                      minLength={6}
                      maxLength={6}
                    />
                    {otpError && (
                      <div
                        className="error-message"
                        style={{ fontSize: "12px", position: "static" }}
                      >
                        {otpError}
                      </div>
                    )}{" "}
                  </div>
                  <div className="d-flex justify-content-center"><Countdown date={new Date().setSeconds(new Date().getSeconds() + 90)} renderer={renderer} /></div>
                </>
              }
              {/* {(userDetails?.email && userDetails?.isEmailVerified) &&
                <div className="popup-body">
                  <p>Is your request urgent?
                    premium users can get their queries resolved by
                    one of our dedicated customer care reps.

                    Premium users also get access to a host of
                    additional benefits!</p>
                </div>
              } */}
              {/* button */}
              {(!userDetails?.email || !userDetails?.isEmailVerified) &&
                <button className='submit-button verify-text' onClick={() => {
                  handleValidateButtonClick()
                }}>
                  verify {subscriptionItem?.amount}
                </button>
                // :
                // <button className='submit-button verify-text' onClick={() => {
                //   redeemSubscription()
                // }}>
                //   explore Vi premium {subscriptionItem?.amount} 
                // </button>
              }
            </div>
          </div>
        </div>
      </div>
      :
      <></>
  );
};

export default SubscriptionPopup;
